export enum agencyType {
    office = 'OFFICE',
    company = 'COMPANY',
    user = 'INDIVIDUAL',
    freeWork = 'FREEWORK',
}